module.exports = __webpack_public_path__ + "static/media/wa-background.adbccee0.png";